import { Endowment as Domain } from 'modules/cm/RepaymentStrategy/Endowment';
import { EndowmentId as Id } from './Endowment';
import create from './create';
import remove from './remove';
import update from './update';

const api = (repaymentStrategyEndoint: string) => {
  const endpoint = `${repaymentStrategyEndoint}/endowments`;

  return {
    create: () => create(endpoint),
    remove: (id: Id) => remove(endpoint, id),
    update: (id: Id, property: Partial<Domain>) => update(endpoint, id, property),
  };
};

export default api;
